import { Container, Navbar, Nav, NavDropdown, Row, Col, Button, Image, ListGroup } from 'react-bootstrap';

//https://aerportfoliobucket.s3.amazonaws.com/MyMainPic.jpg

function MyAbout() {
  let pfp = "https://aerportfoliobucket.s3.amazonaws.com/MyMainPic.jpg";
    return (
        <Row id="MyAbout">
          <Row>
            
          </Row>
          <Col className="d-flex  align-items-center justify-content-center" xs={4}>
            <Image  fluid roundedCircle src={pfp}></Image>
          </Col>
          <Col id="aboutDescription">
            <Row >
              <h1 className="text-center">About Me:</h1>
              <p>
              I became invested in technology when I was a kid. Through video games I first started with low-level modding lua files for a gmod server I ran. In high school I studied web development, introductory programming, and dabbled with different hardwares- one time I made my own elevator pass to use in the morning!

                I am curious and persistent to learn many new technologies each day, that will help craft a better tomorrow.

              </p>
            </Row>
            <Row>
            <ListGroup className="justify-content-center" horizontal>
              <ListGroup.Item>
                <Button className="projectButton" id="profile-link" target="_blank" rel="noopener noreferrer" href="https://github.com/AlexRaschid">
                  <i className="fa-brands fa-github"></i>
                </Button>
              </ListGroup.Item>
              <ListGroup.Item>
                <Button className="projectButton" target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/alexander-raschid/">
                <i className="fa-brands fa-linkedin-in"></i>
                </Button>
              </ListGroup.Item>
              <ListGroup.Item>
                <Button className="projectButton" target="_blank" rel="noopener noreferrer" href="https://www.freecodecamp.org/alexraschid">
                <i className="fa-brands fa-free-code-camp"></i>
                </Button>
              </ListGroup.Item>
            </ListGroup>
            </Row>
          </Col>
          
        </Row>
    );
  }
  
export default MyAbout;